import { JSONSchema6 } from "json-schema";

const cancelChargeSchema: JSONSchema6 = {
    title: "Cancel Charge",
    description: "Moves Charge to Canceled state and releases any authorized payments. You can call this operation until Capture is initiated while Charge is in an AuthorizationInitiated or Authorized state.",
    properties: {
        "pathParam": {
            title: "chargeId",
            type: "string",
        },
        "payload": {
            type: "object",
            properties: {
                "cancellationReason": {
                    type: "string"
                }
            },
        required: ["cancellationReason"]
        }
    },
    required: ["pathParam", "payload"]
}

export default cancelChargeSchema